export const getPollingInterval = ({ pairing: { pollingInterval } }) => pollingInterval;

export const getPairingToken = ({ pairing: { token } }) => token;

export const getPairingURI = ({ pairing: { verificationURI } }) => verificationURI;

export const getPairingStatus = ({ pairing: { status } }) => status;

export const getUserEmail = ({ pairing: { email } }) => email;

export const getPhotoUrl = ({ pairing: { photoUrl } }) => photoUrl;

export const getUserFullName = ({ pairing: { firstname, lastname } }) => `${firstname} ${lastname}`;

export const getPremiumServices = ({ pairing: { subscriptions } }) => subscriptions;

export const isKidsSection = ({ layout: { currentSectionCode } }) => currentSectionCode === 'kids';

export const getIsUnpairedEntering = ({ pairing: { isUnpairedEntering = false } }) => isUnpairedEntering;

export const getParentalLockStatus = ({ pairing: { parentalControl }, features: { parentalFilterFeature } }) =>
  parentalFilterFeature ? parentalControl || 0 : null;

export const getHasOffer = state =>
  getPremiumServices(state) && getPremiumServices(state).some(service => service.offer);

export const getSelectedProfile = state => state.pairing.selectedProfileUid;
